import { getLogger, LOG_LEVELS } from 'ia-react-core';
import { error, log } from 'omni-package-react-logging';

const logger = getLogger();

logger.reporters.push((namespace, level, ...args) => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  if (level === LOG_LEVELS.ERROR) {
    error('error', { ...args });
  }
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  if (level === LOG_LEVELS.INFO) {
    log('information', args.join());
  }
});

export default logger;
